/**
 * 수상·인증 갤러리 카드 클릭 시 세부정보 모달 (큰 사진 + 연한 표)
 */
const MODAL_ID = "achievements-detail-modal";
const LIST_ROOT_SELECTOR = "#achievements-awards";
const CARD_SELECTOR = ".no-achievements-awards__link[data-award-detail]";

function getLenis() {
    return (
        window.lenis ||
        (typeof window.app !== "undefined" &&
            window.app?.utils?.lenis?.getInstance?.()) ||
        null
    );
}

function escapeHtml(text) {
    if (text == null || text === "") return "";
    const div = document.createElement("div");
    div.textContent = String(text);
    return div.innerHTML;
}

let achievementModalLenisStopped = false;

function openModal(modal, data) {
    const titleEl = modal.querySelector("[data-modal-title]");
    const imgWrap = modal.querySelector("[data-modal-img-wrap]");
    const imgEl = modal.querySelector("[data-modal-img]");
    const tbody = modal.querySelector("[data-modal-tbody]");

    if (titleEl) titleEl.textContent = data.title || "";

    if (data.image && imgEl && imgWrap) {
        imgEl.src = data.image;
        imgEl.alt = data.title || "";
        imgWrap.hidden = false;
    } else if (imgWrap) {
        imgWrap.hidden = true;
    }

    if (tbody) {
        tbody.innerHTML = (data.rows || [])
            .map(
                ([label, value]) =>
                    `<tr><th scope="row">${escapeHtml(label)}</th><td>${escapeHtml(value)}</td></tr>`
            )
            .join("");
    }

    modal.hidden = false;
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";

    const lenis = getLenis();
    if (lenis && !achievementModalLenisStopped) {
        lenis.stop();
        achievementModalLenisStopped = true;
    }
}

function closeModal(modal) {
    modal.hidden = true;
    modal.classList.remove("is-open");
    document.body.style.overflow = "";

    if (achievementModalLenisStopped) {
        const lenis = getLenis();
        lenis?.start();
        achievementModalLenisStopped = false;
    }
}

export function initAchievementDetailModal() {
    const modal = document.getElementById(MODAL_ID);
    const root = document.querySelector(LIST_ROOT_SELECTOR);
    if (!modal || !root) return;

    /* 섹션[data-sub-text-anim]에 GSAP transform이 걸리면 fixed가 뷰포트가 아닌 섹션 기준이 됨 → body로 이동 */
    if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
    }

    root.addEventListener("click", (e) => {
        const card = e.target.closest(CARD_SELECTOR);
        if (!card) return;

        const raw = card.getAttribute("data-award-detail");
        if (!raw) return;

        try {
            const data = JSON.parse(raw);
            e.preventDefault();
            openModal(modal, data);
        } catch (err) {
            // JSON parse error: allow default link behavior
        }
    });

    modal.querySelectorAll("[data-achievements-modal-close]").forEach((el) => {
        el.addEventListener("click", () => closeModal(modal));
    });

    modal.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !modal.hidden) {
            closeModal(modal);
        }
    });
}
